import { GeneratorStatusExceedanceDetailQuery } from "generated-graphql/graphql";

export type EvidenceMonth =
  GeneratorStatusExceedanceDetailQuery["generatorStatusExceedanceDetail"]["calculatedMonths"][number];

/** The same membership controls the count, filtering and highlighting. */
export function affectedMonthPeriods({
  months,
  mismatchPeriodStarts,
  mismatchMonths,
}: {
  months: readonly EvidenceMonth[];
  mismatchPeriodStarts?: readonly string[] | null;
  mismatchMonths?: number | null;
}): Set<string> {
  if (mismatchMonths === 0) return new Set();
  return new Set(
    mismatchPeriodStarts?.length
      ? mismatchPeriodStarts
      : months.filter((month) => month.inRun).map((month) => month.periodStart)
  );
}
